import PropTypes from 'prop-types';
// @flow

import React from 'react';

import shallowCompare from 'react-addons-shallow-compare';
// -- constants
import Events from 'constants/Events';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- entities
import {
  RestaurantMenu,
  ProductCategory,
  Product,
  ProductOption,
  Menu
} from 'PMT/entities/menu';

// -- views
import AbstractFormComponent from 'components/form/AbstractFormComponent';

export default class AbstractRestaurantMenuComponent extends AbstractFormComponent {

  static propTypes = {
    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired
  };

  state = this.getDefaultState();

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return true;
    // return shallowCompare(this, nextProps, nextState);
  }

  getDefaultState(): Object {
    return {
      restaurantMenu: this.props.restaurantMenu.copy()
    }
  }

  haveModifications(): boolean {
    return !this.props.restaurantMenu.equals(this.restaurantMenu);
  }

  shouldDisableSubmit(): boolean {
    return false;
  }

  onSubmit = () => {
    this.showLoading();
    RestaurantMenuAction.saveRestaurantMenu(this.state.restaurantMenu);
  };


  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  // -- category modal

  onDisplayCategoryDetail = (categoryToDisplay: ProductCategory) => {
    RouteAction.presentCategoryDetail(categoryToDisplay);
  };

  // -- product modal

  onDisplayProductDetail = (productToDisplay: Product) => {
    RouteAction.presentProductEdit(productToDisplay);
  };

  // -- menu modal

  onDisplayMenuDetail = (menuToDisplay: Menu) => {
    RouteAction.presentMenuDetail(menuToDisplay);
  };

  // -- product option modal

  onDisplayProductOptionDetail = (productOptionToDisplay: ProductOption) => {
    RouteAction.presentProductOptionDetail(productOptionToDisplay);
  };

}



// WEBPACK FOOTER //
// ./scripts/pages/menu/components/AbstractRestaurantMenuComponent.js